import { render, staticRenderFns } from "./UserProfileContactPrefs.vue?vue&type=template&id=77e58afd&scoped=true&"
import script from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
export * from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileContactPrefs.vue?vue&type=style&index=0&id=77e58afd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e58afd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VContainer,VFlex,VForm,VLayout,VProgressCircular,VRadio,VRadioGroup,VSpacer,VSwitch})
